import React, { Component } from "react";
import { Field } from "redux-form";
import { Card, CardContent, Grid, Paper } from "@material-ui/core";
import { renderTextField } from "../../form-global-components/components-form-components-for-react-final-form";
class FormFieldsTabChangeLog extends Component {
  render() {
    return (
      <div>
        <Paper>
          <Card>
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Field
                    disabled
                    component={renderTextField}
                    id="referralcreatedbylogin"
                    name="referralcreatedbylogin"
                    label="Referral Created By ID"
                    emptyText=""
                    footerMessage=""
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    disabled
                    component={renderTextField}
                    id="referralcreatedbyname"
                    name="referralcreatedbyname"
                    label="Referral Created By Name"
                    emptyText=""
                    footerMessage=""
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Field
                    disabled
                    component={renderTextField}
                    id="referrallasttouchedbylogin"
                    name="referrallasttouchedbylogin"
                    label="Referral Last Modified By ID"
                    emptyText=""
                    footerMessage=""
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    disabled
                    component={renderTextField}
                    id="referrallasttouchedbyname"
                    name="referrallasttouchedbyname"
                    label="Referral Last Modified By Name"
                    emptyText=""
                    footerMessage=""
                  />
                </Grid>
              </Grid>

              <br />
              <hr />
              <br />

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Field
                    disabled
                    component={renderTextField}
                    id="clientcreatedbylogin"
                    name="clientcreatedbylogin"
                    label="Client Created By ID"
                    emptyText=""
                    footerMessage=""
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    disabled
                    component={renderTextField}
                    id="clientcreatedbyname"
                    name="clientcreatedbyname"
                    label="Client Created By Name"
                    emptyText=""
                    footerMessage=""
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Field
                    disabled
                    component={renderTextField}
                    id="clientlasttouchedbylogin"
                    name="clientlasttouchedbylogin"
                    label="Client Last Modified By ID"
                    emptyText=""
                    footerMessage=""
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    disabled
                    component={renderTextField}
                    id="clientlasttouchedbyname"
                    name="clientlasttouchedbyname"
                    label="Client Last Modified By Name"
                    emptyText=""
                    footerMessage=""
                  />
                </Grid>
              </Grid>

              <br />
              <hr />
              <br />

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Field
                    disabled
                    component={renderTextField}
                    id="postdischarecreatedbylogin"
                    name="postdischarecreatedbylogin"
                    label="Post Discharge Created By ID"
                    emptyText=""
                    footerMessage=""
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    disabled
                    component={renderTextField}
                    id="postdischarecreatedbyname"
                    name="postdischarecreatedbyname"
                    label="Post Discharge Created By Name"
                    emptyText=""
                    footerMessage=""
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Field
                    disabled
                    component={renderTextField}
                    id="postdischarelasttouchedbylogin"
                    name="postdischarelasttouchedbylogin"
                    label="Post Discharge Last Modified By ID"
                    emptyText=""
                    footerMessage=""
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    disabled
                    component={renderTextField}
                    id="postdischarelasttouchedbyname"
                    name="postdischarelasttouchedbyname"
                    label="Post Discharge Last Modified By Name"
                    emptyText=""
                    footerMessage=""
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Paper>
      </div>
    );
  }
}
FormFieldsTabChangeLog.propTypes = {};
export default FormFieldsTabChangeLog;
